export function url(
  selected_tab: string,
  proposal_id: string | false | undefined,
  user_id?: string | false | null | undefined,
  cv_id?: string | false | null | undefined,
): string {
  if (user_id == null) {
    user_id = false;
  }
  if (cv_id == null) {
    cv_id = false;
  }
  if (proposal_id == null) {
    proposal_id = false;
  }
  const base_url = `${selected_tab}/proposal/${proposal_id}`;
  if (!user_id || !cv_id) {
    return base_url;
  }
  return `${base_url}/cv/${user_id}/${cv_id}/`;
}

export function anchored_url(
  selected_tab: string,
  proposal_id: string | false | undefined,
  user_id?: string | false | undefined,
  cv_id?: string | false | undefined,
): string {
  const fragment = url(selected_tab, proposal_id, user_id, cv_id);

  return `/${fragment}`;
}

export function proposal_share_url(proposal_id: string | false): string {
  return `${anchored_url("persons", proposal_id)}/share`;
}

function reference_url(
  selected_tab: string,
  proposal_id: string | false,
  company_customer_id: string | null | undefined,
  company_project_id: string | null | undefined,
  reference_project_id: string | null | undefined,
  language_code: string | null | undefined,
): string {
  const base_url = `${selected_tab}/proposal/${proposal_id}`;
  if (
    !company_customer_id ||
    !company_project_id ||
    !reference_project_id ||
    !language_code
  ) {
    return base_url;
  }
  return `${base_url}/reference_in_proposal/${company_customer_id}/${company_project_id}/${reference_project_id}/${language_code}`;
}

export function anchored_reference_url(
  selected_tab: string,
  proposal_id: string | false,
  company_customer_id: string | null | undefined,
  company_project_id: string | null | undefined,
  reference_project_id: string | null | undefined,
  language_code: string | null | undefined,
): string {
  const fragment = reference_url(
    selected_tab,
    proposal_id,
    company_customer_id,
    company_project_id,
    reference_project_id,
    language_code,
  );

  return `/${fragment}`;
}

export function profileUrl(
  user: { user_id: string; default_cv_id: string | null },
  readOnly: boolean,
  proposalId: string | null | undefined,
): string {
  const fragment = url(
    "persons",
    proposalId ?? "false",
    user.user_id,
    user.default_cv_id,
  );
  return `/dashboard#/${fragment}read_only${readOnly ? "/default" : ""}`;
}
